// Services.
import {WaHelperService} from '../../wa-services/wa-helper-service';
import {FactoryService} from '../../wa-services/factory-service';

// Classes.
import {AthleteGeneralInfoItem} from './athlete-general-info.item';
import {AthleteResultItem} from './athlete-result.item';


export class AthleteResultInfoItem extends AthleteGeneralInfoItem {
  public countryName: string;
  public countryNameShort: string;
  public gender: string;
  public dob: Date;
  public results: AthleteResultItem[];


  constructor(rawAthleteResultInfoItem: any,
    protected waHelperService: WaHelperService,
    protected factory: FactoryService) {
    super(rawAthleteResultInfoItem, waHelperService);

    // Those data are extracted form wa helper.
//    this.countryName = rawAthleteResultInfoItem.CountryName;
//    this.countryNameShort = rawAthleteResultInfoItem.CountryShort;
    this.gender = rawAthleteResultInfoItem.Gender;
    const tmpDate = new Date(rawAthleteResultInfoItem.DoB);
    this.dob = new Date(
      new Date(
        new Date(tmpDate).getTime() +
          Math.abs(new Date(tmpDate).getTimezoneOffset() * 60000)
      ));
    this.results = rawAthleteResultInfoItem.Results.map(rawAthleteResultItem => this.factory.newAthleteResultItem(rawAthleteResultItem));

  }

  get genderLabel(): string {
    let label: string;
    switch (this.gender) {
      case 'M':
        label = 'Men';
        break;
      case 'W':
        label = 'Women';
        break;
    }

    return label;
  }
}
